import { checkUserEmail, firstAccessPassword } from '@services/sm-api.js'

// Primeiro acesso no login V2 — mesma regra do V1 (LoginModal, 02/09/2026): conta sem
// senha local (criada pelo login com Google, por exemplo) não consegue entrar com
// e-mail e senha; em vez de "senha incorreta", recebe o e-mail de cadastro de senha
// (link para a página V2). Falha na checagem não bloqueia: segue para o login normal.
export const FIRST_ACCESS_SENT = email =>
  `Sua conta ainda não tem senha cadastrada. Enviamos para ${email} um link para você criar a sua. Se preferir, entre com o Google.`
export const FIRST_ACCESS_ERROR = 'Não foi possível enviar o e-mail de cadastro de senha. Tente novamente.'

// null = seguir com o login; 'sent' = e-mail enviado; 'error' = falha no envio
export const checkFirstAccess = async email => {
  let data
  try {
    data = await checkUserEmail(email)
  } catch (e) {
    return null
  }
  if (!data || data.exists === false || data.set_password !== false) return null
  try {
    await firstAccessPassword({ email, origin: 'v2' })
    return 'sent'
  } catch (e) {
    return 'error'
  }
}
